{
  "loading": "Notiek ielāde...",
  "placeholder": "Atlasiet opciju..."
}